import * as authActions from './auth/actions.js';
// Side-effect import: registers socket event subscriptions for active users
import './users/activeUsersActions.js';
import * as creditorsActions from './creditors/actions.js';
import * as exclusiveContentActions from './exclusiveContent/actions.js';
import * as langActions from './lang/actions.js';
import * as localActions from './local/actions.js';
import * as newInteractions from './newInteractions/actions.js';
import * as redirectActions from './redirect/actions.js';
export default {
    auth: authActions,
    creditors: creditorsActions,
    lang: langActions,
    exclusiveContent: exclusiveContentActions,
    local: localActions,
    redirect: redirectActions,
    newInteractions: newInteractions,
};
//# sourceMappingURL=actions.js.map